import React from 'react';
import { LabelAndTooltipStyles as styles } from './FormFieldsV3InlineStyles';
import { TooltipIcon } from 'components/svgs/TooltipIcon.ts';
import { Popup } from 'semantic-ui-react';

interface ILabelAndTooltipProps {
  labelText?: string;
  tooltipText?: string;
}

const LabelAndTooltip = ({ labelText, tooltipText }: ILabelAndTooltipProps) => {
  if (!labelText && !tooltipText) {
    return null;
  }
  return (
    <div style={styles.labelAndTooltipContainer}>
      {labelText ? <div style={styles.label}>{labelText}</div> : null}
      {tooltipText ? (
        <Popup
          hideOnScroll={true}
          content={tooltipText}
          on="click"
          // SUIR only enables preventOverflow when `offset` is set — without it
          // the popup runs off the right edge on narrow screens
          popperModifiers={[
            {
              name: 'preventOverflow',
              enabled: true,
              options: { padding: 8 },
            },
          ]}
          trigger={
            <div style={styles.tooltip}>
              <TooltipIcon />
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default LabelAndTooltip;
